import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LabelElement } from './label.component';
import { createCustomElement } from '@angular/elements';
import { InterrogationModule } from '@bazis/shared/components/web/interrogation/interrogation.module';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { BadgeModule } from '@bazis/shared/components/web/badge/badge.module';

@NgModule({
    declarations: [LabelElement],
    imports: [CommonModule, InterrogationModule, IconModule, BadgeModule],
    exports: [LabelElement],
})
export class LabelModule implements DoBootstrap {
    constructor(private injector: Injector) {}

    ngDoBootstrap(): void {
        const el = createCustomElement(LabelElement, {
            injector: this.injector,
        });

        customElements.define('bazis-label', el);
    }
}
